var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.nowTime > _vm.preBegin)?_c('div',{staticClass:"state-pre"},[(_vm.nowTime > _vm.preRes)?_c('pre-result'):(_vm.nowTime > _vm.preEnd)?_c('pre-ended'):(_vm.nowTime > _vm.preBegin)?_c('pre-playing'):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }